import type { ColumnDef } from "@tanstack/react-table";
import { ReviewBadge } from "@/accounts-payable/common";
import type { ApReceipt } from "@/accounts-payable/types";

export const reviewCol: ColumnDef<ApReceipt> = {
  accessorKey: "review_state",
  header: "Review",
  meta: { size: "130px" },
  cell: ({ row }) => <ReviewBadge document={row.original} />,
};
